var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59103 20.706C8.77336 20.8888 9.01934 20.9941 9.2775 20.9997C9.53565 21.0053 9.78596 20.9108 9.97603 20.736L22.676 9.062C22.8712 8.88276 22.9873 8.63337 22.9987 8.36862C23.0101 8.10387 22.916 7.84541 22.737 7.65L18.785 3.325C18.6962 3.22791 18.5891 3.1493 18.4699 3.09367C18.3507 3.03805 18.2216 3.00649 18.0902 3.00083C17.9587 2.99516 17.8275 3.01549 17.7039 3.06065C17.5803 3.10581 17.4669 3.17491 17.37 3.264L9.50503 10.494L6.84403 7.827C6.65275 7.64597 6.39939 7.54509 6.13603 7.54509C5.87267 7.54509 5.61931 7.64597 5.42803 7.827L1.29203 11.974C1.10517 12.1614 1.00024 12.4153 1.00024 12.68C1.00024 12.9447 1.10517 13.1986 1.29203 13.386L8.59103 20.706ZM6.13603 9.949L8.76703 12.586C8.94918 12.7687 9.19488 12.8739 9.4528 12.8797C9.71072 12.8855 9.96089 12.7914 10.151 12.617L17.985 5.417L20.585 8.266L9.33003 18.614L3.41203 12.68L6.13603 9.949Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.1a245d8667e6f3137abe172ae1e7f6ee.svg";
export { ForwardRef as ReactComponent };